{"dirty":false,"raw":"e38b85d19","hash":"e38b85d19","distance":null,"tag":null,"semver":null,"suffix":"e38b85d19","semverString":null}